import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import { TipoCampoFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';
import {
  ConfiguracionTablaAsincrona,
  TipoColumnaTabla,
} from 'src/app/compartido/tabla/utilidades/tabla.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';
import { formatearFecha } from 'src/app/compartido/utilidades/valores.utils';
import { EstadoOrden } from 'src/app/ordenes/utilidades/ordenes.models';

/* Configuración de la ficha de preparar órdenes */
export const CONFIGURACION_FICHA_PREPARAR_ORDENES: ConfiguracionFicha = {
  header: { titulo: 'Preparar Órdenes', icono: Icono.PREPARACION },
  maxWidth: 900,
};

/* Configuración de la tabla de preparar órdenes */
export const CONFIGURACION_TABLA_PREPARAR_ORDENES: ConfiguracionTablaAsincrona =
  {
    columnas: [
      { nombre: 'ID', slug: 'id' },
      { nombre: 'Título', slug: 'titulo' },
      { nombre: 'N° Referencia', slug: 'referencia' },
      {
        nombre: 'Fecha Creación',
        slug: 'fecha_creacion',
        tipo: TipoColumnaTabla.FECHA,
        ordenable: true,
      },
      {
        nombre: 'Aplazada',
        slug: 'aplazada',
        tipo: TipoColumnaTabla.BOOLEANO,
      },
      // { nombre: 'Items', slug: 'items', tipo: TipoColumnaTabla.NUMERO },
      { nombre: 'Fórmulas', slug: 'formulas', tipo: TipoColumnaTabla.NUMERO },
    ],
    filtros: [
      {
        nombre: 'Organización',
        slug: 'organizacion',
        tipo: TipoCampoFormulario.NUMERO,
        oculto: true,
      },
      {
        nombre: 'Punto de Origen',
        slug: 'origen_null',
        tipo: TipoCampoFormulario.NUMERO,
        oculto: true,
      },
      {
        nombre: 'Estado',
        slug: 'estado',
        tipo: TipoCampoFormulario.TEXTO,
        oculto: true,
        valor: EstadoOrden.POR_PREPARAR,
      },
      {
        nombre: 'Fecha Creación',
        slug: 'fecha_creacion',
        tipo: TipoCampoFormulario.FECHA,
      },
      {
        nombre: 'Incluir Aplazadas Hasta',
        slug: 'aplazada_hasta',
        tipo: TipoCampoFormulario.FECHA,
        valor: formatearFecha(new Date()),
      },
    ],
    busqueda: true,
    botones: undefined,
    acciones: [
      {
        nombre: 'Preparar',
        slug: 'preparar',
        icono: Icono.PREPARACION,
      },
    ],
    omitirCargaInicial: true,
  };
